module.exports = {
  whiteModeColor: {
    textColor1: "#3737B9",
    mainColor1: "#7f7fd5",
    mainColor2: "#86a8e7",
    mainColor3: "#91eac9",
  },
  darkModeColor: {
    textColor1: "#bd93f9",
    mainColor1: "#ff79c6",
    mainColor2: "#bd93f9",
    mainColor3: "#6272a4",
  },
}
